import { ExporterTemplate } from '@src/core';

const AmandaColenExporter: ExporterTemplate = {
  filename: 'Variáveis Amanda Colen',
  labels: [
    { collectNumber: 1, description: '24 a 48 horas pós-parto', color: 'e06666' },
    { collectNumber: 2, description: '8 a 10 dias pós-parto', color: '3c78d8' },
    { collectNumber: 3, description: '40 a 45 dias pós-parto', color: '6aa84f' },
    { collectNumber: 4, description: '3 meses após o parto', color: 'e69138' },
  ],
  exporterSettings: [
    // ID
    {
      dataOrigin: { source: 'contact', propertyName: 'id' },
      dataType: 'number',
      label: 'ID', // ID
    },
    // Idade
    {
      dataOrigin: { source: 'collect', collectNumber: 1, propertyName: 'age' },
      dataType: 'number',
      label: 'IDADE', // Idade
    },
    // Escolaridade
    {
      dataOrigin: { source: 'collect', collectNumber: 1, propertyName: 'education' },
      dataType: 'category-number',
      label: 'ESCOLARIDADE', // ESCOLARIDADE: Até que ano você estudou?

      categoryRules: [
        {
          value: 1,
          label: 'Ensino Fundamental I (1 a 4 série)',
          condition: {
            operator: 'in',
            reference: ['Fundamental I (1ª a 5ª série)'],
          },
        },
        {
          value: 2,
          label: ' Ensino Fundamental II (5 a 9 série)',
          condition: {
            operator: 'in',
            reference: ['Fundamental II (6ª a 9ª série)'],
          },
        },
        {
          value: 3,
          label: 'Médio completo',
          condition: { operator: 'equal', reference: 'Médio (antigo 2ª grau)' },
        },
        {
          value: 4,
          label: 'Superior (Completo ou Incompleto)',
          condition: { operator: 'equal', reference: 'Superior' },
        },
      ],
    },
    // Situação conjugal
    {
      dataOrigin: { source: 'collect', collectNumber: 1, propertyName: 'maritalSituation' },
      label: 'SITUACAO_CONJUGAL', // 'SITUAÇÃO CONJUGAL?

      dataType: 'category-number',
      categoryRules: [
        {
          value: 1,
          label: 'Sem companheiro',
          condition: { operator: 'equal', reference: 'Sem companheiro' },
        },
        {
          value: 2,
          label: 'Com companheiro',
          condition: { operator: 'equal', reference: 'Com companheiro' },
        },
      ],
    },
    // Paridade
    {
      dataOrigin: { source: 'collect', collectNumber: 1, propertyName: 'question04' },
      dataType: 'category-number',
      label: 'PARIDADE', // 4. Número de gestações?

      categoryRules: [
        {
          value: 1,
          label: 'Primipara',
          condition: { operator: 'less', reference: 2 },
        },
        {
          value: 2,
          label: 'Multípara (dois ou mais parto prévios)',
          condition: { operator: 'greater-than', reference: 2 },
        },
      ],
    },
    // Idade gestacional
    {
      dataOrigin: { source: 'collect', collectNumber: 1, propertyName: 'question03' },
      dataType: 'category-number',
      label: 'IDADE_GESTACIONAL', // 3. Idade gestacional completa?

      categoryRules: [
        {
          value: 1,
          label: 'Pré-termo (menos de 37 semanas)',
          condition: { operator: 'less', reference: 37 },
        },
        {
          value: 2,
          label: 'Termo ( 37 a 41 semanas)',
          condition: { operator: 'greater-than', reference: 37 },
        },
      ],
    },
    // IMC pré-gestacional
    {
      dataOrigin: { source: 'collect', collectNumber: 1, propertyName: 'question01' },
      dataType: 'category-number',
      label: 'IMC_PRE_GESTACIONAL', // 1. Índice de Massa Corporal pré-gestacional?

      categoryRules: [
        {
          value: 1,
          label: 'Abaixo do peso (IMC <18,5)',
          condition: { operator: 'less', reference: 18.5 },
        },
        {
          value: 2,
          label: 'Eutrófica (IMC 18,5 a  24,9)',
          condition: { operator: 'between', reference: [18.5, 24.99] },
        },
        {
          value: 3,
          label: 'Sobrepeso (IMC 25 a 29)',
          condition: { operator: 'between', reference: [25, 29.99] },
        },
        {
          value: 4,
          label: 'Obesidade (IMC ≥ 30)',
          condition: { operator: 'greater-than', reference: 30 },
        },
      ],
      useFieldData: 'answerIMC',
    },
    // IMC atual
    {
      dataOrigin: { source: 'collect', collectNumber: 1, propertyName: 'question02' },
      dataType: 'category-number',
      label: 'IMC_ATUAL', // 2. Índice de Massa Corporal atual?

      categoryRules: [
        {
          value: 1,
          label: 'Abaixo do peso (IMC <18,5)',
          condition: { operator: 'less', reference: 18.5 },
        },
        {
          value: 2,
          label: 'Eutrófica (IMC 18,5 a  24,9)',
          condition: { operator: 'between', reference: [18.5, 24.99] },
        },
        {
          value: 3,
          label: 'Sobrepeso (IMC 25 a 29)',
          condition: { operator: 'between', reference: [25, 29.99] },
        },
        {
          value: 4,
          label: 'Obesidade (IMC ≥ 30)',
          condition: { operator: 'greater-than', reference: 30 },
        },
      ],
      useFieldData: 'answerIMC',
    },
    // Episiotomia prévia
    {
      dataOrigin: { source: 'collect', collectNumber: 1, propertyName: 'question05-1' },
      dataType: 'category-number',
      label: 'EPISIOTOMIA_PREVIA', // 5.1. Se teve "Parto vaginal" anterior, houve "episiotomia"?

      categoryRules: [
        {
          value: 1,
          label: 'Não',
          //condition: { operator: 'equal', reference: 'Não' },
          condition: { operator: 'no-equal', reference: 'Sim' },
        },
        {
          value: 2,
          label: 'Sim',
          condition: { operator: 'equal', reference: 'Sim' },
        },
      ],
    },
    // Rafia de laceração prévia
    {
      dataOrigin: { source: 'collect', collectNumber: 1, propertyName: 'question05-2' },
      dataType: 'category-number',
      label: 'RAFIA_DE_LACERACAO_PREVIA', // 5.2. Se teve "Parto vaginal" anterior, houve "rafia de laceração"?

      categoryRules: [
        {
          value: 1,
          label: 'Não',
          //condition: { operator: 'in', reference: ['Não', 'Não sabe dizer'] },
          condition: { operator: 'no-equal', reference: 'Sim' },
        },
        {
          value: 2,
          label: 'Sim',
          condition: { operator: 'equal', reference: 'Sim' },
        },
      ],
    },
    // Dispareunia antes da gravidez
    {
      dataOrigin: { source: 'collect', collectNumber: 3, propertyName: 'question15' },
      dataType: 'category-number',
      label: 'DISPAREUNIA_ANTES_DA_GRAVIDEZ', // 15. Antes de engravidar, sentia dor durante as relações sexuais?

      categoryRules: [
        {
          value: 1,
          label: 'Não',
          condition: {
            operator: 'equal',
            reference: 'Nenhuma',
          },
        },
        {
          value: 2,
          label: 'Sim',
          condition: {
            operator: 'no-equal',
            reference: 'Nenhuma',
          },
        },
      ],
    },
    // Variáveis da escala REEDA
    {
      dataOrigin: { source: 'collect', collectNumber: 1, propertyName: 'question22-6' },
      dataType: 'number',
      label: 'CICATRIZACAO_DO_PERINEO', // 22.6 Score TOTAL REEDA?
    },
    {
      dataOrigin: { source: 'collect', collectNumber: 1, propertyName: 'question22-1' },
      dataType: 'category-number',
      label: 'HIPEREMIA_NO_PERINEO', // 22.1 Realizar a avaliação perineal de acordo com escala REEDA [HIPEREMIA]?

      categoryRules: [
        {
          value: 0,
          label: 'Ausência de hiperemia',
          condition: {
            operator: 'equal',
            reference: 'Score 0 - Nenhuma',
          },
        },
        {
          value: 1,
          label: 'Menos de 0,25 cm em torno da ferida',
          condition: {
            operator: 'equal',
            reference: 'Score 1 - Até 0,25 cm da incisão bilateralmente',
          },
        },
        {
          value: 2,
          label: 'Entre 0,25 e 0,5 cm em torno da ferida',
          condition: {
            operator: 'equal',
            reference: 'Score 2 - Até 0,5 cm da incisão bilateralmente',
          },
        },
        {
          value: 3,
          label: 'Mais de 0,5 cm em torno da ferida',
          condition: {
            operator: 'equal',
            reference: 'Score 3 - Além de 0,5 cm da incisão bilateralmente',
          },
        },
      ],
    },
    {
      dataOrigin: { source: 'collect', collectNumber: 1, propertyName: 'question22-2' },
      dataType: 'category-number',
      label: 'EDEMA_NO_PERINEO', // 22.2 Realizar a avaliação perineal de acordo com escala REEDA [EDEMA]?

      categoryRules: [
        {
          value: 0,
          label: 'Ausência de edema',
          condition: {
            operator: 'equal',
            reference: 'Score 0 - Nenhuma',
          },
        },
        {
          value: 1,
          label: 'Leve',
          condition: {
            operator: 'equal',
            reference: 'Score 1 - Perineal a menos de 1 cm a partir da incisão',
          },
        },
        {
          value: 2,
          label: 'Moderado',
          condition: {
            operator: 'equal',
            reference: 'Score 2 - Perineal ou vulvar de 1 a 2 cm da incisão',
          },
        },
        {
          value: 3,
          label: 'Intenso',
          condition: {
            operator: 'equal',
            reference: 'Score 3 - Perineal ou vulvar além de 2 cm da incisão',
          },
        },
      ],
    },
    {
      dataOrigin: { source: 'collect', collectNumber: 1, propertyName: 'question22-3' },
      dataType: 'category-number',
      label: 'EQUIMOSE_NO_PERINEO', // 22.3 Realizar a avaliação perineal de acordo com escala REEDA [EQUIMOSE]?

      categoryRules: [
        {
          value: 0,
          label: 'Ausência',
          condition: {
            operator: 'equal',
            reference: 'Score 0 - Nenhuma',
          },
        },
        {
          value: 1,
          label: '<1 cm em torno da ferida',
          condition: {
            operator: 'equal',
            reference: 'Score 1 - Até 0,25 cm da incisão bilateralmente ou 0,25 cm unilateralmente',
          },
        },
        {
          value: 2,
          label: 'Entre 1 cm e 2 cm em torno na ferida',
          condition: {
            operator: 'equal',
            reference: 'Score 2 - Entre 0,25 e 1 cm bilateralmente ou entre 0,5 e 2 cm unilateralmente',
          },
        },
        {
          value: 3,
          label: '>2 cm em torno da ferida',
          condition: {
            operator: 'equal',
            reference: 'Score 3 - Além de 1 cm bilateralmente ou 2 cm unilateralmente',
          },
        },
      ],
    },
    {
      dataOrigin: { source: 'collect', collectNumber: 1, propertyName: 'question22-4' },
      dataType: 'category-number',
      label: 'SECRECAO_NA_LESAO_DO_PERINEO', // 22.4 Realizar a avaliação perineal de acordo com escala REEDA [SECREÇÃO]?

      categoryRules: [
        {
          value: 0,
          label: 'Nenhuma',
          condition: {
            operator: 'equal',
            reference: 'Score 0 - Nenhuma',
          },
        },
        {
          value: 1,
          label: 'Serosa',
          condition: {
            operator: 'equal',
            reference: 'Score 1 - Serosa',
          },
        },
        {
          value: 2,
          label: 'Seropurulenta',
          condition: {
            operator: 'equal',
            reference: 'Score 2 - Serosanguínea',
          },
        },
        {
          value: 3,
          label: 'Purulenta',
          condition: {
            operator: 'equal',
            reference: 'Score 3 - Sanguinolenta, purulenta',
          },
        },
      ],
    },
    {
      dataOrigin: { source: 'collect', collectNumber: 1, propertyName: 'question22-5' },
      dataType: 'category-number',
      label: 'COAPTACAO_DAS_BORDAS', // 22.5 Realizar a avaliação perineal de acordo com escala REEDA [COAPTAÇÃO]?

      categoryRules: [
        {
          value: 0,
          label: 'Bordas bem aproximadas',
          condition: {
            operator: 'equal',
            reference: 'Score 0 - Fechada',
          },
        },
        {
          value: 1,
          label: 'Separação leve das bordas',
          condition: {
            operator: 'equal',
            reference: 'Score 1 - Pele separada 3 mm ou menos',
          },
        },
        {
          value: 2,
          label: 'Separação de até 0,5 cm das bordas',
          condition: {
            operator: 'equal',
            reference: 'Score 2 - Pele e subcutâneo separados',
          },
        },
        {
          value: 3,
          label: 'Separação maior que 0,5 cm das bordas',
          condition: {
            operator: 'equal',
            reference: 'Score 3 - Pele, subcutâneo e músculo separados',
          },
        },
      ],
    },
    // END: Variáveis da escala REEDA
    // Sensação de Bem estar pós-parto
    {
      dataOrigin: { source: 'collect', collectNumber: 1, propertyName: 'question32' },
      dataType: 'category-number',
      label: 'SENSACAO_DE_BEM_ESTAR_POS_PARTO', // 32. Sensação de "voltar ao meu normal

      categoryRules: [
        {
          value: 1,
          label: 'Me sinto muito bem',
          condition: {
            operator: 'equal',
            reference: 'Me sinto muito bem, "de volta ao meu normal"',
          },
        },
        {
          value: 2,
          label: 'Me sinto bem, porém ainda desconfortável',
          condition: {
            operator: 'equal',
            reference: 'Me sinto bem, porém ainda desconfortável, acredito que logo estarei "de volta ao meu normal"',
          },
        },
        {
          value: 3,
          label: 'Não me sinto bem comigo, acho que irei demorar para voltar ao meu normal',
          condition: {
            operator: 'equal',
            reference: 'Não me sinto bem comigo, acho que irei demorar para "voltar ao meu normal"',
          },
        },
      ],
    },
    // Dor ou desconforto na região suturada ao sentar-se
    {
      dataOrigin: { source: 'collect', collectNumber: 1, propertyName: 'question24' },
      dataType: 'category-number',
      label: 'DOR_DESCONFORTO_SUTURA_AO_SENTAR', // 24. Capacidade de sentar

      categoryRules: [
        {
          value: 1,
          label: 'Sem dor ou desconforto',
          condition: {
            operator: 'equal',
            reference: 'Consigo sentar confortavelmente',
          },
        },
        {
          value: 2,
          label: 'Dor ou desconforto leve a moderado',
          condition: {
            operator: 'equal',
            reference: 'Consigo sentar com um pouco de desconforto',
          },
        },
        {
          value: 3,
          label: 'Dor ou desconforto intenso',
          condition: {
            operator: 'in',
            reference: ['Consigo sentar com muito desconforto', 'Não consigo sentar'],
          },
        },
      ],
    },
    // Dor ou desconforto na região suturada ao andar
    {
      dataOrigin: { source: 'collect', collectNumber: 1, propertyName: 'question25' },
      dataType: 'category-number',
      label: 'DOR_DESCONFORTO_SUTURA_AO_ANDAR', // 25. Capacidade de andar

      categoryRules: [
        {
          value: 1,
          label: 'Sem dor ou desconforto',
          condition: {
            operator: 'not-in',
            reference: ['Consigo andar com um pouco de desconforto', 'Consigo andar com muito desconforto'],
          },
        },
        {
          value: 2,
          label: 'Dor ou desconforto leve a moderado',
          condition: {
            operator: 'equal',
            reference: 'Consigo andar com um pouco de desconforto',
          },
        },
        {
          value: 3,
          label: 'Dor ou desconforto intenso',
          condition: {
            operator: 'equal',
            reference: 'Consigo andar com muito desconforto',
          },
        },
      ],
    },
    // Dor ao evacuar pós-parto
    {
      dataOrigin: { source: 'collect', collectNumber: 1, propertyName: 'question28' },
      dataType: 'category-number',
      label: 'DOR_AO_EVACUAR_POS_PARTO', // 28. Capaz de evacuar sem dor/ ou medo de rompimento dos pontos.

      categoryRules: [
        {
          value: 1,
          label: 'Não',
          condition: {
            operator: 'in',
            reference: ['Consegui tranquilamente', 'Tive medo, mas consegui sem dor'],
          },
        },
        {
          value: 2,
          label: 'Sim',
          condition: {
            operator: 'equal',
            reference: 'Consegui, com muita dor',
          },
        },
        {
          value: 3,
          label: 'Não evacuou',
          condition: {
            operator: 'equal',
            reference: 'Não consegui',
          },
        },
      ],
    },
    // Dor ao urinar pós-parto
    {
      dataOrigin: { source: 'collect', collectNumber: 1, propertyName: 'question29' },
      dataType: 'category-number',
      label: 'DOR_AO_URINAR_POS_PARTO', // 29. Capaz de urinar sem dor/ ou medo.

      categoryRules: [
        {
          value: 1,
          label: 'Não',
          condition: {
            operator: 'in',
            reference: ['Consegui tranquilamente', 'Tive medo, mas consegui sem dor'],
          },
        },
        {
          value: 2,
          label: 'Sim',
          condition: {
            operator: 'equal',
            reference: 'Consegui, com muita dor',
          },
        },
        {
          value: 3,
          label: 'Não urinei',
          condition: {
            operator: 'equal',
            reference: 'Não consegui',
          },
        },
      ],
    },
    // Autopercepção do bem estar físico (coleta 2, 3 e 4)
    ...[
      { collectNumber: 2, suffix: '08A10D', color: '3c78d8' },
      { collectNumber: 3, suffix: '40A45D', color: '6aa84f' },
      { collectNumber: 4, suffix: '03M', color: 'e69138' },
    ].map(
      (c: any) =>
        ({
          dataOrigin: { source: 'collect', collectNumber: c.collectNumber, propertyName: 'question01' },
          dataType: 'category-number',
          label: `AUTOPERCEPCAO_BEM_ESTAR_FISICO_${c.suffix}`, // 1. Como você diria que está se sentindo fisicamente?

          categoryRules: [
            {
              value: 1,
              label: 'Muito bem',
              condition: {
                operator: 'in',
                reference: ['Muito bem', 'Muito Bem'],
              },
            },
            {
              value: 2,
              label: 'Razoavelmente bem',
              condition: {
                operator: 'equal',
                reference: 'Razoavelmente bem',
              },
            },
            {
              value: 3,
              label: 'Não muito bem',
              condition: {
                operator: 'equal',
                reference: 'Não muito bem',
              },
            },
            {
              value: 4,
              label: 'Nada bem',
              condition: {
                operator: 'equal',
                reference: 'Nada bem',
              },
            },
          ],
        }) as any
    ),
    // Percepção do aspecto da área suturada (coleta 2, 3 e 4)
    ...[
      { collectNumber: 2, suffix: '08A10D', propertyName: 'question09' },
      { collectNumber: 3, suffix: '40A45D', propertyName: 'question08' },
      { collectNumber: 4, suffix: '03M', propertyName: 'question08' },
    ].map(
      (c: any) =>
        ({
          dataOrigin: { source: 'collect', collectNumber: c.collectNumber, propertyName: c.propertyName },
          dataType: 'category-number',
          label: `PERCEPCAO_ASPECTO_AREA_SUTURADA_${c.suffix}`, // X. Depois de olhar a área onde você foi suturada/com pontos:

          categoryRules: [
            {
              value: 1,
              label: 'Melhor do que o esperado',
              condition: {
                operator: 'equal',
                reference: 'Parecia ou teve a sensação de estar MELHOR do que você pensava',
              },
            },
            {
              value: 2,
              label: 'Pior do que o esperado',
              condition: {
                operator: 'equal',
                reference: 'Parecia ou teve a sensação de estar PIOR do que você pensava',
              },
            },
            {
              value: 3,
              label: 'Não conseguiu avaliar',
              condition: {
                operator: 'equal',
                reference: 'Não conseguiu ver ou sentir',
              },
            },
          ],
        }) as any
    ),
    // Percepção da recuperação do períneo (coleta 2, 3 e 4)
    ...[
      { collectNumber: 2, suffix: '08A10D', propertyName: 'question10' },
      { collectNumber: 3, suffix: '40A45D', propertyName: 'question09' },
      { collectNumber: 4, suffix: '03M', propertyName: 'question09' },
    ].map(
      (c: any) =>
        ({
          dataOrigin: { source: 'collect', collectNumber: c.collectNumber, propertyName: c.propertyName },
          dataType: 'category-number',
          label: `PERCEPCAO_RECUPERACAO_PERINEO_${c.suffix}`, // X. Depois de olhar a área onde você foi suturada/com pontos:

          categoryRules: [
            {
              value: 1,
              label: 'Recuperado, como antes do parto',
              condition: {
                operator: 'equal',
                reference: 'Sinto que meu períneo/vagina está cicatrizado, está de volta ao normal',
              },
            },
            {
              value: 2,
              label: 'Cicatrizando bem, quase de volta ao normal',
              condition: {
                operator: 'equal',
                reference: 'Sinto que meu períneo/vagina está cicatrizando bem, está quase de volta ao normal',
              },
            },
            {
              value: 3,
              label: 'Cicatrizado, mas com menos elasticidade',
              condition: {
                operator: 'equal',
                reference:
                  'Sinto que meu períneo/vagina cicatrizou, porém, ficou com menor elasticidade e não está de volta ao normal',
              },
            },
            {
              value: 4,
              label: 'Está cicatrizando mal, muito diferente do habitual',
              condition: {
                operator: 'equal',
                reference: 'Sinto que meu períneo/vagina está cicatrizando muito mal, longe de voltar ao normal',
              },
            },
          ],
        }) as any
    ),
    // Dor ou desconforto perineal pós-parto (coleta 1, 2, 3 e 4)
    ...[
      // 26. Sobre a dor perineal (no local dos pontos)
      { collectNumber: 1, suffix: '24A48H', propertyName: 'question26' },
      // X. Como você descreveria a intensidade da dor ou desconforto?
      { collectNumber: 2, suffix: '08A10D', propertyName: 'question04' },
      { collectNumber: 3, suffix: '40A45D', propertyName: 'question03' },
      { collectNumber: 4, suffix: '03M', propertyName: 'question04' },
    ].map(
      (c: any) =>
        ({
          dataOrigin: { source: 'collect', collectNumber: c.collectNumber, propertyName: c.propertyName },
          dataType: 'category-number',
          label: `DOR_DESCONFORTO_PERINEAL_${c.suffix}`,

          categoryRules: [
            {
              value: 1,
              label: 'Sem dor',
              condition: {
                operator: 'in',
                reference: ['Nenhuma', 'Não sinto dor'],
              },
            },
            {
              value: 2,
              label: 'Dor leve',
              condition: {
                operator: 'in',
                reference: ['Leve', 'Sinto dor leve'],
              },
            },
            {
              value: 3,
              label: 'Dor moderada',
              condition: {
                operator: 'in',
                reference: ['Moderado', 'Sinto dor moderada'],
              },
            },
            {
              value: 4,
              label: 'Dor severa',
              condition: {
                operator: 'in',
                reference: ['Grave', 'Sinto dor severa'],
              },
            },
          ],
        }) as any
    ),
    // Frequência de dor ou desconforto perineal (coleta 2, 3 e 4)
    ...[
      // X. Se existe dor ou desconforto, qual a frequência?
      { collectNumber: 2, suffix: '08A10D', propertyName: 'question05' },
      { collectNumber: 3, suffix: '40A45D', propertyName: 'question04' },
      { collectNumber: 4, suffix: '03M', propertyName: 'question05' },
    ].map(
      (c: any) =>
        ({
          dataOrigin: { source: 'collect', collectNumber: c.collectNumber, propertyName: c.propertyName },
          dataType: 'category-number',
          label: `FREQUENCIA_DOR_DESCONFORTO_PERINEAL_${c.suffix}`,
          categoryRules: [
            {
              value: 1,
              label: 'Pouco frequente',
              condition: {
                operator: 'equal',
                reference: 'Pouco frequente',
              },
            },
            {
              value: 2,
              label: 'Quase sempre',
              condition: {
                operator: 'equal',
                reference: 'Quase sempre',
              },
            },
            {
              value: 3,
              label: 'Sempre',
              condition: {
                operator: 'equal',
                reference: 'Sempre',
              },
            },
          ],
        }) as any
    ),
    // Dor perineal relacionada a atividades funcionais (coleta 2, 3 e 4)
    ...[
      // Cuidados com o bebê
      { criteria: 'AO_AMAMENTAR', subQuestionNumber: '1' },
      { criteria: 'AO_TROCAR_O_BEBE', subQuestionNumber: '8' },
      { criteria: 'AO_CARREGAR_O_BEBE', subQuestionNumber: '9' },
      // Movimentos funcionais diários
      { criteria: 'AO_CAMINHAR', subQuestionNumber: '2' },
      { criteria: 'AO_PERMANECER_EM_PE', subQuestionNumber: '3' },
      { criteria: 'AO_SENTAR', subQuestionNumber: '4' },
      { criteria: 'AO_DEITAR', subQuestionNumber: '5' },
      { criteria: 'AO_SUBIR_DESCER_DA_CAMA', subQuestionNumber: '6' },
      { criteria: 'AO_CURVAR_E_ABAIXAR', subQuestionNumber: '7' },
      // Tarefas domésticas
      { criteria: 'AO_REALIZAR_TAREFAS_DOMESTICAS', subQuestionNumber: '10' },
      // Necessidades fisiológicas
      { criteria: 'AO_EVACUAR', subQuestionNumber: '12' },
      { criteria: 'AO_URINAR', subQuestionNumber: '11' },
    ]
      .map((c: any) =>
        [
          // X. Nas últimas 24 horas, quanta dor ou desconforto você sentiu na área onde foi suturada/com pontos ao fazer as seguintes atividades:
          { collectNumber: 2, suffix: '08A10D', propertyName: 'question07' },
          { collectNumber: 3, suffix: '40A45D', propertyName: 'question06' },
          { collectNumber: 4, suffix: '03M', propertyName: 'question06' },
        ].map(
          (d: any) =>
            ({
              dataOrigin: {
                source: 'collect',
                collectNumber: d.collectNumber,
                propertyName: `${d.propertyName}-${c.subQuestionNumber}`,
              },
              dataType: 'category-number',
              label: `DOR_PERINEAL_${c.criteria}_${d.suffix}`,

              categoryRules: [
                {
                  value: 1,
                  label: 'Nenhum',
                  condition: {
                    operator: 'equal',
                    reference: 'Nenhum',
                  },
                },
                {
                  value: 2,
                  label: 'Leve',
                  condition: {
                    operator: 'equal',
                    reference: 'Leve',
                  },
                },
                {
                  value: 3,
                  label: 'Moderado',
                  condition: {
                    operator: 'equal',
                    reference: 'Moderado',
                  },
                },
                {
                  value: 4,
                  label: 'Grave',
                  condition: {
                    operator: 'equal',
                    reference: 'Grave',
                  },
                },
              ],
            }) as any
        )
      )
      .flatMap(v => v),
    // Tempo até cessar a dor e/ou desconforto perineal
    {
      dataOrigin: { source: 'collect', collectNumber: 4, propertyName: 'question03' },
      dataType: 'category-number',
      label: 'TEMPO_ATE_CESSAR_DOR_DESCONFORTO_PERINEAL', // 3. Se a dor ou desconforto da área onde você foi suturada/com pontos parou, quando isso ocorreu?
      categoryRules: [
        {
          value: 1,
          label: 'Não senti dor ou desconforto',
          condition: {
            operator: 'equal',
            reference: 'Nunca senti dor ou desconforto',
          },
        },
        {
          value: 2,
          label: 'Até 4 semanas pós-parto',
          condition: {
            operator: 'in',
            reference: ['Na primeira semana após o nascimento do bebê', '2-4 semanas após o nascimento do seu bebê'],
          },
        },
        {
          value: 3,
          label: 'Mais de 4 semanas ou ainda está presente',
          condition: {
            operator: 'in',
            reference: [
              '5-8 semanas após o nascimento do seu bebê',
              '9-12 semanas após o nascimento do seu bebê',
              'Ainda sinto dor ou desconforto',
            ],
          },
        },
      ],
    },
    // Uso de analgésico para dor perineal
    {
      dataOrigin: { source: 'collect', collectNumber: 2, propertyName: 'question02' },
      dataType: 'category-number',
      label: 'USO_ANALGESICO_PARA_DOR_PERINEAL_08A10D', // 2. Você precisou tomar algum analgésico para a dor ou desconforto da área onde foi suturada/com pontos?
      categoryRules: [
        {
          value: 1,
          label: 'Não',
          condition: {
            operator: 'equal',
            reference: 'Não',
          },
        },
        {
          value: 2,
          label: 'Sim',
          condition: {
            operator: 'equal',
            reference: 'Sim',
          },
        },
      ],
    },
    // Incontinência urinária pós-parto (coleta 2, 3 e 4)
    ...[
      { collectNumber: 2, suffix: '08A10D', propertyName: 'question12' },
      { collectNumber: 3, suffix: '40A45D', propertyName: 'question11' },
      { collectNumber: 4, suffix: '03M', propertyName: 'question12' },
    ].map(
      (c: any) =>
        ({
          dataOrigin: { source: 'collect', collectNumber: c.collectNumber, propertyName: c.propertyName },
          dataType: 'category-number',
          label: `INCONTINENCIA_URINARIA_POS_PARTO_${c.suffix}`, // X.Você experimentou algum dos seguintes sintomas AO URINAR?
          categoryRules: [
            {
              value: 1,
              label: 'Não',
              condition: {
                operator: 'equal',
                reference:
                  'Não sentiu nenhum dos sintomas desde o partoNão sentiu nenhum desses sintomas desde o nascimento do seu bebê',
              },
            },
            {
              value: 2,
              label: 'Sim',
              condition: {
                operator: 'no-equal',
                reference:
                  'Não sentiu nenhum dos sintomas desde o partoNão sentiu nenhum desses sintomas desde o nascimento do seu bebê',
              },
            },
          ],
        }) as any
    ),

    // Incontinência intestinal pós-parto (coleta 2, 3 e 4)
    ...[
      { collectNumber: 2, suffix: '08A10D', propertyName: 'question13' },
      { collectNumber: 3, suffix: '40A45D', propertyName: 'question12' },
      { collectNumber: 4, suffix: '03M', propertyName: 'question13' },
    ].map(
      (c: any) =>
        ({
          dataOrigin: { source: 'collect', collectNumber: c.collectNumber, propertyName: c.propertyName },
          dataType: 'category-number',
          label: `INCONTINENCIA_INTESTINAL_POS_PARTO_${c.suffix}`, // X.Você experimentou algum dos seguintes sintomas AO URINAR?
          categoryRules: [
            {
              value: 1,
              label: 'Não',
              condition: {
                operator: 'equal',
                reference: 'Não experimentou nenhum sintoma',
              },
            },
            {
              value: 2,
              label: 'Sim',
              condition: {
                operator: 'no-equal',
                reference: 'Não experimentou nenhum sintoma',
              },
            },
          ],
        }) as any
    ),

    // Método de alívio da dor ou desconforto perineal (coleta 2, 3 e 4)
    ...[
      // X. Nas últimas 24 horas, você precisou fazer uso de algum método para aliviar dor ou desconforto dos pontos?
      { collectNumber: 2, suffix: '08A10D', propertyName: 'question03' },
      { collectNumber: 3, suffix: '40A45D', propertyName: 'question02' },
      { collectNumber: 4, suffix: '03M', propertyName: 'question02' },
    ].map(
      (c: any) =>
        ({
          dataOrigin: { source: 'collect', collectNumber: c.collectNumber, propertyName: c.propertyName },
          dataType: 'category-number',
          label: `METODO_ALIVIO_DOR_DESCONFORTO_${c.suffix}`,
          categoryRules: [
            {
              value: 1,
              label: 'Procurou ajuda de hospital',
              condition: {
                operator: 'equal',
                reference: 'Precisei procurar ajuda em um hospital',
              },
            },
            {
              value: 2,
              label: 'Utilizou métodos naturais',
              condition: {
                operator: 'equal',
                reference: 'Utilizei métodos naturais que foram suficientes',
              },
            },
            {
              value: 3,
              label: 'Utilizou analgésicos em casa',
              condition: {
                operator: 'equal',
                reference: 'Utilizei analgésico que tenho em casa',
              },
            },
          ],
        }) as any
    ),
    // Retomada da atividade sexual pós-parto
    ...[
      // X. Conseguiu retomar a atividade sexual sem dor à penetração?
      { collectNumber: 3, suffix: '40A45D', propertyName: 'question14' },
      { collectNumber: 4, suffix: '03M', propertyName: 'question15' },
    ].map(
      (c: any) =>
        ({
          dataOrigin: { source: 'collect', collectNumber: c.collectNumber, propertyName: c.propertyName },
          dataType: 'category-number',
          label: `RETOMADA_ATIVIDADE_SEXUAL_${c.suffix}`,
          categoryRules: [
            {
              value: 1,
              label: 'Não',
              condition: {
                operator: 'equal',
                reference: 'Não realizei tentativa',
              },
            },
            {
              value: 2,
              label: 'Sim',
              condition: {
                operator: 'no-equal',
                reference: 'Não realizei tentativa',
              },
            },
          ],
        }) as any
    ),
    // Dispareunia na retomada pós-parto
    ...[
      // X. Conseguiu retomar a atividade sexual sem dor à penetração?
      { collectNumber: 3, suffix: '40A45D', propertyName: 'question14' },
      { collectNumber: 4, suffix: '03M', propertyName: 'question15' },
    ].map(
      (c: any) =>
        ({
          dataOrigin: { source: 'collect', collectNumber: c.collectNumber, propertyName: c.propertyName },
          dataType: 'category-number',
          label: `DISPAREUNIA_RETOMADA_POS_PARTO_${c.suffix}`,
          categoryRules: [
            {
              value: 1,
              label: 'Não',
              condition: {
                operator: 'equal',
                reference: 'Consegui, não senti dor',
              },
            },
            {
              value: 2,
              label: 'Sim',
              condition: {
                operator: 'in',
                reference: [
                  'Tentei, porém, senti muita dor',
                  'Consegui, porém, senti dor moderada',
                  'Consegui, senti pouca dor',
                ],
              },
            },
            {
              value: 3,
              label: 'Não se aplica',
              condition: {
                operator: 'equal',
                reference: 'Não realizei tentativa',
              },
            },
          ],
        }) as any
    ),
    // Intensidade da dor à penetração
    ...[
      // X. Conseguiu retomar a atividade sexual sem dor à penetração?
      { collectNumber: 3, suffix: '40A45D', propertyName: 'question14' },
      { collectNumber: 4, suffix: '03M', propertyName: 'question15' },
    ].map(
      (c: any) =>
        ({
          dataOrigin: { source: 'collect', collectNumber: c.collectNumber, propertyName: c.propertyName },
          dataType: 'category-number',
          label: `INTENSIDADE_DOR_A_PENETRACAO_${c.suffix}`,
          categoryRules: [
            {
              value: 1,
              label: 'Sem dor',
              condition: {
                operator: 'equal',
                reference: 'Consegui, não senti dor',
              },
            },
            {
              value: 2,
              label: 'Dor leve',
              condition: {
                operator: 'equal',
                reference: 'Consegui, senti pouca dor',
              },
            },
            {
              value: 3,
              label: 'Dor moderada',
              condition: {
                operator: 'equal',
                reference: 'Consegui, porém, senti dor moderada',
              },
            },
            {
              value: 4,
              label: 'Dor intensa',
              condition: {
                operator: 'equal',
                reference: 'Tentei, porém, senti muita dor',
              },
            },
          ],
        }) as any
    ),
    // Tempo de retorno a atividade sexual pos-parto
    {
      dataOrigin: { source: 'collect', collectNumber: 4, propertyName: 'question16' },
      dataType: 'category-number',
      label: 'TEMPO_RETORNO_A_ATIVIDADE_SEXUAL_03M', // 16. Se você tentou retomar atividade sexual, com quantas semanas após o nascimento do seu bebê você realizou a tentativa pela primeira vez?
      categoryRules: [
        {
          value: 1,
          label: '2 semanas',
          condition: {
            operator: 'equal',
            reference: 'Dentro de 2 semanas após o nascimento do seu bebê',
          },
        },
        {
          value: 2,
          label: '2 a 4 semanas',
          condition: {
            operator: 'equal',
            reference: '3-4 (1 mês) semanas após o nascimento do seu bebê',
          },
        },
        {
          value: 3,
          label: '5 a 8 semanas',
          condition: {
            operator: 'equal',
            reference: '5-8 (2 meses) semanas após o nascimento do seu bebê',
          },
        },
        {
          value: 4,
          label: '9 a 12 semanas',
          condition: {
            operator: 'equal',
            reference: '9-12 (3 meses) semanas após o nascimento do seu bebê',
          },
        },
      ],
    },
    // Percepção da atividade sexual pós-retomada
    {
      dataOrigin: { source: 'collect', collectNumber: 4, propertyName: 'question19' },
      dataType: 'category-number',
      label: 'PERCEPCAO_DA_ATIVIDADE_SEXUAL_APOS_RETOMADA_03M', // 19. Após retomar as relações sexuais, como você classifica a relação?
      categoryRules: [
        {
          value: 1,
          label: 'Mais prazerosa',
          condition: {
            operator: 'equal',
            reference: 'Mais prazerosa',
          },
        },
        {
          value: 2,
          label: 'Menos prazerosa',
          condition: {
            operator: 'equal',
            reference: 'Menos prazerosa',
          },
        },
        {
          value: 3,
          label: 'O mesmo que antes',
          condition: {
            operator: 'equal',
            reference: 'O mesmo que antes',
          },
        },
      ],
    },
  ],
};

export { AmandaColenExporter };
